export const APPLICATION_ERROR_MESSAGE = 'Przepraszamy, wystpił błąd aplikacji.';
